import React  from "react";
import { useParams } from 'react-router-dom';
import AccessRightForm from "./components/AccessRightForm";

const EditAccessRight = () => {
	const { rightId } = useParams();
    
	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<AccessRightForm recordId={rightId} mode="edit"/>
	      </div>
	    </div>
    );
};

export default EditAccessRight;